var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.969,
    height: 20.782,
    viewBox: "0 0 20.969 20.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(-277.702 -255.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M-11105,10386.748l2.4-3.708h-19.085l7.551,10.711v8.785l4.395-2.059v-4.41",
    transform: "translate(11400.353 -10126.965)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-customer-7",
    d: "M6.625,22.075C5.6,21.837,4.436,21.231,4.9,20.356c1.405-2.664.373-4.088-1.111-4.088-1.514,0-2.521,1.479-1.112,4.088.476.88-.725,1.486-1.727,1.719C.031,22.287,0,22.743,0,23.54l0,.3H7.57v-.29C7.574,22.746,7.543,22.287,6.625,22.075Z",
    transform: "translate(290.923 244.26)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFilter);
export default __webpack_public_path__ + "static/media/project_filter.a508aa9fabb5c9f76bc32fe41f9d4633.svg";
export { ForwardRef as ReactComponent };